import React, { useState, useEffect, useRef } from "react"
import JoditEditor from "jodit-react"


const config = {


    placeholder: 'Start typings...',


    readonly: false, // Enable editing
    height: 500,
    toolbarSticky: false, // Toolbar stays in place
    toolbarButtonSize: "middle", // Button size in toolbar
    uploader: {
        insertImageAsBase64URI: true, // Allow uploading images as Base64 (no backend needed)
    },
    buttons: [
        "source", // HTML source code view
        "|",
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "eraser", // Remove formatting
        "|",
        "superscript", // Superscript text
        "subscript", // Subscript text
        "|",
        "ul", // Unordered list
        "ol", // Ordered list
        "outdent", // Outdent
        "indent", // Indent
        "|",
        "font", // Font family
        "fontsize", // Font size
        "brush", // Text color
        "paragraph", // Paragraph formatting
        "|",
        "image", // Insert image
        "video", // Insert video
        "table", // Insert table
        "link", // Insert hyperlink
        "|",
        "align", // Text alignment
        "undo", // Undo action
        "redo", // Redo action
        "copyformat", // Copy formatting
        "cut", // Cut
        "copy", // Copy
        "paste", // Paste
        "|",
        "fullsize", // Fullscreen mode
        "preview", // Preview
        "print", // Print content
    ],
    font: {
        defaultFont: "Arial",
        list: [
            "Arial",
            "Verdana",
            "Georgia",
            "Roboto",
            "Open Sans",
            "Times New Roman",
            "Courier New",
            "Tahoma",
            "Comic Sans MS",
            "Impact",
        ],
    },
    fontsize: [10, 12, 14, 16, 18, 20, 22, 24, 28, 32, 36, 48, 72],
    showCharsCounter: true,
    showWordsCounter: true,
    showXPathInStatusbar: false,
}

const RichTextEditorCustom = ({ value = "", onChange, className = "" }) => {

    // const editor = useRef(null)

    // useEffect(() => {
    //   if (editor.current && value !== content) {
    //     setContent(value)
    //     editor.current?.editor?.setEditorValue(value)
    //   }
    // }, [value, content])

    // const handleChange = (newContent) => {
    //   setContent(newContent)
    //   if (onChange) {
    //     onChange(newContent)
    //   }
    // }


    return (
        <JoditEditor
            style={{ backgroundColor: "transparent" }}
            value={value}
            config={config}
            onChange={onChange}

        />
    )
}

export default RichTextEditorCustom
